import { Dialog, Transition } from "@headlessui/react";
import LoadingSpinner from "../loadingSpinner";
import { Fragment } from "react";

const PdfGeneratingModal = ({ show, showModalHandler, printedPdf }) => {
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => showModalHandler(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="flex flex-col items-center w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                {!printedPdf && (
                  <>
                    <LoadingSpinner color="#5EAA9B" size={12} />
                    <Dialog.Title as="h3" className="mt-4 text-lg font-medium leading-6 text-gray-900">
                      Your PDF is generating.
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500 text-center">
                        It could take 1-2 minutes to generate. Please be patient.
                      </p>
                    </div>
                  </>
                )}

                {printedPdf && (
                  <>
                    <Dialog.Title as="h3" className="mb-3 text-lg font-medium leading-6 text-gray-900">
                      Your PDF is ready.
                    </Dialog.Title>
                    <a href={printedPdf.file} target="_blank" rel="noreferrer" onClick={() => showModalHandler(false)}>
                      <span className="transition hover:bg-pinto-dark cursor-pointer inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md  bg-pinto text-white">
                        Download
                      </span>
                    </a>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PdfGeneratingModal;
